export default __webpack_public_path__ + "static/lets-talk03-a8281b8088264c02c8fe7da0f6726509.png";